import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MessagePopupComponent } from '../modals/message-popup/message-popup.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  modal;
  constructor(
    private authenticationService: AuthenticationService,
    private modalService: BsModalService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status == 401) {
          // auto logout if 401 response returned from api
          console.log('error in interceptor', err);
          this.authenticationService.logout();
        } else {
          if (err.error.message) {
            this.modalService.hide();
            setTimeout(() => {
              const user = this.authenticationService.userValue;
              if (!this.modal && user) {
                this.modal = this.modalService.show(MessagePopupComponent, {
                  initialState: {
                    title: 'error',
                    text: err.error.message,
                    buttonText: 'okay',
                  },
                  class: 'alert-modal modal-dialog-centered',
                  backdrop: 'static',
                });
                this.modal.onHidden.subscribe(() => {
                  this.modal = null;
                });
              }
            }, 500);
          }
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      }),
    );
  }
}
